<body class="ltr main-body leftmenu">
    <form autocomplete="off" novalidate>
        <!-- Main Content-->
        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <div class="row row-sm">
                        <div class="col-lg-12">
                            <div class="card custom-card">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-8">
                                            <div class=" d-flex align-items-center pl-3">
                                                <img alt="Logo" src="../../assets/img/ExamMaster.png"
                                                    class="mh-45px pb-2">
                                                <div class="ml-2">
                                                    <h3 class="main-content-label mb-1"><b>
                                                            Question Paper Codes
                                                        </b></h3>
                                                    <p class="text-muted card-sub-title mb-0">
                                                        {{ ' Add New Question Paper Information' | translate }}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- <div class="col-md-3" [formGroup]="CollegeDataSearchForm">
                                            <mat-form-field appearance="outline" class="example-full-width">
                                                <mat-label>{{'header.college-data.titleList.Search' | translate}}
                                                </mat-label> <input class="color" matInput placeholder="Search"
                                                    (keyup)="keypress()" formControlName="SearchString">
                                                <mat-icon matSuffix>search</mat-icon>
                                            </mat-form-field>
                                        </div>  -->
                                        <div class="col-md-3"></div>
                                         <div class="col-md-1 prpl1">
                                            <button type="button" (click)="print()" class="btn sz btn-primary btn-icon-text floatright mt-1 fr">
                                                <span style="display: contents; align-items: center;">
                                                    <img width="20vh" src="../../assets/img/printer.gif" style="margin-right: 7px;">
                                                    Print
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                    <hr>

                                    <div class="row row-sm add-form">
                                        <form autocomplete="off" class="p-0" novalidate
                                            [formGroup]="QuestionPaperCodeForm">
                                            <div class="col-lg-12 col-md-12">
                                                <div class="row clearfix">
                                                    <div class="col-sm-4">
                                                        <div class="form-group">
                                                            <div class="">

                                                                <mat-form-field appearance="outline"
                                                                    class="example-full-width">
                                                                    <mat-label> Exam</mat-label>
                                                                    <mat-select formControlName="ShId" #select23
                                                                        class="colorblack">
                                                                        <mat-select-filter *ngIf="select23.focused"
                                                                            [placeholder]="'Filter'"
                                                                            [displayMember]="'EmShName'"
                                                                            [array]="examListForOP"
                                                                            (filteredReturn)=" filteredexamListForOP =$event"></mat-select-filter>
                                                                        <mat-option
                                                                            *ngFor="let item of  filteredexamListForOP"
                                                                            [value]="item.ShEmId"
                                                                            (click)="fetchQPForTable(item.ShId)">
                                                                            {{item.EmShName}}
                                                                        </mat-option>
                                                                    </mat-select>
                                                                </mat-form-field>


                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-4">
                                                        <div class="form-group">
                                                            <div class="">

                                                                <mat-form-field appearance="outline"
                                                                    class="example-full-width">
                                                                    <mat-label> Branch</mat-label>
                                                                    <input matInput formControlName="CSExBr"
                                                                        placeholder="Course Mediums">
                                                                </mat-form-field>


                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-12">
                                                        <hr *ngIf="showLine==true">
                                                    </div>

                                                    <div class="col-sm-12 align-right">
                                                    </div>
                                                </div>
                                            </div>


                                            <div class="col-sm-12 pl-0">
                                                <div>
                                                    <div class="table-responsive" id="table">
                                                        <table class="table  table-bordered ">
                                                            <thead *ngIf="showLine==true">
                                                                <tr class="text-left">
                                                                    <th width="15%" class="f600">
                                                                        Branch
                                                                    </th>
                                                                    <th width="15%" class="f600">
                                                                        Sub Code
                                                                    </th>
                                                                    <th width="50%" class="f600">
                                                                        Sub Name
                                                                    </th>
                                                                    <th width="20%" class="f600">
                                                                        Qp Code
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody formArrayName="NewQPArray">
                                                                <tr *ngFor="let item of getNewCdArrayControls(); let i = index"
                                                                    [formGroupName]="i">
                                                                    <td>
                                                                        <input readonly class="form-control bg input-sm"
                                                                            formControlName="branchName">

                                                                    </td>
                                                                    <td>
                                                                        <input readonly class="form-control bg input-sm"
                                                                            formControlName="subCode">

                                                                    </td>
                                                                    <td>
                                                                        <input readonly class="form-control bg input-sm"
                                                                            formControlName="subName">

                                                                    </td>
                                                                    <td>

                                                                        <input class="form-control input-sm"
                                                                            maxlength="5" formControlName="Code"
                                                                            (change)="valuechange(item)">
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>

                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</body>